"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Numbers = exports.SlidingSlot = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "SlideControls";
exports.classes = {
    mobileFullSize: `${PREFIX}-mobileFullSize`,
    fullSize: `${PREFIX}-fullSize`,
    vertical: `${PREFIX}-vertical`,
    hide: `${PREFIX}-hide`,
    middleContainer: `${PREFIX}-middleContainer`,
    chevron: `${PREFIX}-chevron`,
    up: `${PREFIX}-up`,
    down: `${PREFIX}-down`,
    total: `${PREFIX}-total`,
    active: `${PREFIX}-active`,
    number: `${PREFIX}-number`,
    light: `${PREFIX}-light`
};
const keyframes = {
    fade: `${PREFIX}-fade`,
    slide: `${PREFIX}-slide`
};
const animationDuration = "0.3s";
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    minHeight: "48px",
    [`&.${exports.classes.mobileFullSize}`]: {
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            justifyContent: "space-between"
        }
    },
    [`&.${exports.classes.fullSize}`]: {
        width: "100%",
        justifyContent: "space-between"
    },
    [`&.${exports.classes.vertical}`]: {
        flexDirection: "column",
        [`.${exports.classes.middleContainer}`]: {
            margin: "10px 0",
            padding: "10px 0",
            overflow: "hidden"
        }
    },
    [`&.${exports.classes.hide}`]: {
        [`.${exports.classes.middleContainer}`]: {
            display: "none"
        }
    },
    [`&.${exports.classes.light}`]: {
        [`.${exports.classes.number}, .${exports.classes.total}, .${exports.classes.chevron}`]: {
            color: `${theme.colours.white}cc`,
            "&:hover": {
                color: theme.colours.white
            }
        }
    },
    [`.${exports.classes.middleContainer}`]: {
        display: "flex",
        margin: "0 24px",
        userSelect: "none",
        position: "relative"
    },
    [`.${exports.classes.chevron}`]: {
        width: "37px",
        height: "37px",
        color: theme.colours.slate,
        transition: "0.2s color ease-in-out",
        "&:hover": {
            color: theme.colours.charcoal
        }
    },
    [`.${exports.classes.total}`]: {
        marginLeft: "2px",
        fontSize: "20px",
        color: theme.colours.slate,
        "&::before": {
            content: "'/'",
            display: "inline-block",
            marginRight: "4px"
        }
    },
    [`.${exports.classes.number}`]: {
        fontSize: "20px",
        width: "28px",
        textAlign: "center",
        color: theme.colours.slate,
        animation: `${keyframes.fade} ${animationDuration} ease-in-out reverse both`,
        "&$active": {
            animation: `${keyframes.fade} ${animationDuration} ease-in-out both`
        },
        "&:first-of-type:last-of-type": {
            opacity: 1,
            animation: "none"
        }
    },
    [`@keyframes ${keyframes.fade}`]: {
        "0%": {
            opacity: 0
        },
        "100%": {
            opacity: 1
        }
    }
}));
exports.SlidingSlot = (0, styles_1.styled)("span")({ height: "28px" });
exports.Numbers = (0, styles_1.styled)("span")({
    display: "flex",
    flexDirection: "column",
    [`&.${exports.classes.up}`]: {
        animation: `${keyframes.slide} ${animationDuration} ease-in-out both`
    },
    [`&.${exports.classes.down}`]: {
        animation: `${keyframes.slide} ${animationDuration} ease-in-out reverse both`
    },
    [`@keyframes ${keyframes.slide}`]: {
        "0%": {
            marginTop: 0
        },
        "100%": {
            marginTop: "-100%"
        }
    }
});
//# sourceMappingURL=data:application/json;base64,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